export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar cheque electrónico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta de crédito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de activación"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar cheque electrónico"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Importe"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activado"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelado"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activando"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devolviendo"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pendiente"])}
  }
}